module.exports = __webpack_public_path__ + "img/linkedin-3.00f2e622.svg";